import { Link } from "react-router-dom";
import styled from "styled-components";
import { Search } from "lucide-react";
import { cPath } from "../../constants";

const Box = styled.div`
  background: hsl(${({ theme }) => theme.colors.card});
  border-radius: ${({ theme }) => theme.radius.xl};
  border: 1px solid hsl(${({ theme }) => theme.colors.border});
  padding: 3rem;
  text-align: center;
`;

const BtnRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.75rem;
  margin-top: 1.5rem;
  flex-wrap: wrap;
`;

const Btn = styled(Link)`
  padding: 0.625rem 1.25rem;
  border-radius: ${({ theme }) => theme.radius.lg};
  font-weight: 600;
  font-size: 0.875rem;
  ${({ $primary, theme }) =>
    $primary
      ? `
    background: hsl(${theme.colors.primary});
    color: hsl(${theme.colors.primaryForeground});
    &:hover { opacity: 0.9; }
  `
      : `
    border: 1px solid hsl(${theme.colors.border});
    color: hsl(${theme.colors.foreground});
    &:hover { background: hsl(${theme.colors.muted}); }
  `}
`;

export default function SearchEmptyState() {
  return (
    <Box>
      <Search
        size={48}
        strokeWidth={1.5}
        style={{ margin: "0 auto 1rem", color: "hsl(220 10% 46%)" }}
      />
      <h2
        style={{
          margin: "0 0 0.5rem",
          fontSize: "1.25rem",
          fontWeight: 700,
          color: "hsl(220 40% 13%)",
        }}
      >
        No results found
      </h2>
      <p style={{ margin: 0, color: "hsl(220 10% 46%)" }}>
        Try a different search term or browse our popular options.
      </p>
      <BtnRow>
        <Btn $primary to={cPath("stores")}>
          Browse Stores
        </Btn>
        <Btn to={cPath("categories")}>Browse Categories</Btn>
      </BtnRow>
    </Box>
  );
}
